import React from "react";
import { useTranslation } from "react-i18next";

const MechanicCard = ({ mechanic, lang }) => {
  const { t } = useTranslation();

  const location = mechanic.location?.[lang] || mechanic.location?.en || "";
  const specialties = mechanic.specialties?.map(
    (spec) => spec[lang] || spec.en || ""
  );

  return (
    <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
      <h3 className="text-xl font-bold text-gray-900">{mechanic.name}</h3>

      <p className="text-gray-700">
        {t("mechanic.location")}: {location}
      </p>

      <p className="text-gray-700">
        {t("mechanic.phone")}: {mechanic.phoneNumber}
      </p>

      <p className="text-gray-700">
        {t("mechanic.specialties")}: {specialties?.join(", ")}
      </p>
    </div>
  );
};

export default MechanicCard;
